(function () {
  'use strict';

  angular
    .module('app.store-detail', [])

    .directive('store', function () {
      return {
        restrict: 'E',
        bindToController: {
          device: '<',
          name: '@',
          latitude: '<',
          longitude: '<',
          model: '<',
          daysModel: '@days',
          strOneTime: '@oneTime',
          strTwoTimes: '@twoTimes',
          strClosed: '@closed'
        },
        controllerAs: 'storeCtrl',
        /* @ngInject */
        controller: ["$window", "$filter", "GMaps", function ($window, $filter, GMaps) {
          var ctrl = this;

          ctrl.$onInit = function () {
            ctrl.OpeningHours = _.cloneDeep(ctrl.model);
            ctrl.days = ctrl.daysModel.split(',');
            ctrl.model = null;
            ctrl.daysModel = null;

            setOpeningHours();

            ctrl.loading = true;
            GMaps.get()
              .then(setMap)
              .catch(function (error) {
                console.error(error);
              });

          };

          ctrl.getMarkerOpts = function () {
            return {
              title: null,
              icon: { url: '/img/gmap/store-gmap-active.png', scaledSize: new google.maps.Size(38.5, 50), labelOrigin: new google.maps.Point(20, 60) },
              label: { text: ctrl.name, fontWeight: 'bold' },
              zIndex: 3
            };
          };

          ctrl.activeTab = function () {
            $window.dispatchEvent(new CustomEvent('resize'));
          };

          // Functions

          function setMap() {
            ctrl.markers = [];
            ctrl.markers.push({
              id: 0,
              lat: ctrl.latitude,
              lng: ctrl.longitude
            });

            ctrl.options = {
              map: {
                center: new google.maps.LatLng(ctrl.latitude, ctrl.longitude),
                zoom: 8,
                styles: [{'stylers': [{'saturation': -100}, {'lightness': 50}]}]
              }
            };

            ctrl.showMap = true;
            ctrl.loading = false;
          }

          function setOpeningHours() {
            var tmp = [];
            _.each(ctrl.OpeningHours, function (day, i) {
              var obj = {
                day: ctrl.days[i]
              };

              if (day.IsOpen) {
                  var date, format, amStart, amEnd, pmStart, pmEnd;
                  date = new Date(day.Date1Start.replace('T', ' ').replace(/-/g, '/'));
                  format = !date.getMinutes() ? "H'h'" : "H'h'mm";
                  amStart = $filter('date')(date, format);

                  date = new Date(day.Date1End.replace('T', ' ').replace(/-/g, '/'));
                  format = !date.getMinutes() ? "H'h'" : "H'h'mm";
                  amEnd = $filter('date')(date, format);

                  date = new Date(day.Date2Start.replace('T', ' ').replace(/-/g, '/'));
                  if (date.getFullYear() !== 2001) {
                      format = !date.getMinutes() ? "H'h'" : "H'h'mm";
                      pmStart = $filter('date')(date, format);

                      date = new Date(day.Date2End.replace('T', ' ').replace(/-/g, '/'));
                      format = !date.getMinutes() ? "H'h'" : "H'h'mm";
                      pmEnd = $filter('date')(date, format);
                  }

                  obj.value = !pmStart ? $filter('format')(ctrl.strOneTime, amStart, amEnd) : $filter('format')(ctrl.strTwoTimes, amStart, amEnd, pmStart, pmEnd);
                  obj.value = day.Exception ? obj.value + ' <strong>' + day.Exception + '</strong>' : obj.value;
              } else {
                  obj.value = day.Exception ? '<strong>' + day.Exception + '</strong>' : ctrl.strClosed;
              }
              tmp.push(obj);
            });
            ctrl.OpeningHours = tmp;
          }

        }]
      };
    });

})();
